import { APIService } from "shared/services";
import { API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem, IAPIError } from "shared/types";
import { IEventTravelLegParams, TravelLegType } from "Bands/types";
import { getTravelLegApiEndpoint } from "Bands/utils";

interface IJSONAPITravelLeg {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPITravelLegCollection {
  [IDataKeys.eventFlightTravelLeg]: IJSONAPITravelLeg;
  [IDataKeys.eventBusTravelLeg]: IJSONAPITravelLeg;
  [IDataKeys.eventTrainTravelLeg]: IJSONAPITravelLeg;
  [IDataKeys.eventOtherTravelLeg]: IJSONAPITravelLeg;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventTravelLegService {
  static createTravelLeg = ({
    data,
    travelLegType,
  }: {
    data: IEventTravelLegParams;
    travelLegType: TravelLegType;
  }): Promise<IJSONAPITravelLegCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: getTravelLegApiEndpoint(travelLegType).list,
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.POST_EVENT_TRAVEL_LEG
        );
        return reject(error);
      }
    });

  static editTravelLeg = ({
    id,
    data,
    travelLegType,
  }: {
    id: string;
    data: IEventTravelLegParams;
    travelLegType: TravelLegType;
  }): Promise<IJSONAPITravelLegCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: getTravelLegApiEndpoint(travelLegType).item(id),
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.PATCH_EVENT_TRAVEL_LEG
        );
        return reject(error);
      }
    });

  static deleteTravelLeg = ({
    id,
    travelLegType,
  }: {
    id: string;
    travelLegType: TravelLegType;
  }): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: getTravelLegApiEndpoint(travelLegType).item(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.DELETE_EVENT_TRAVEL_LEG
        );
        return reject(error);
      }
    });
}
